import React from 'react';
import 'bootstrap/dist/js/bootstrap.min';


export default class IntroContent extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        return(
        <div className = "col-sm-12">
            <div className="page-header" id="guides-section-01">
                    <h1 className="blog-title mt20">Coupang Open API Intro</h1>
                </div>
                <div className="blog-post">
                    <h3 className="mt40">Coupang Open API를 이용함으로써 무엇이 개선되나요?</h3>
                    <p>쿠팡의 Open API를 이용하여 여러분의 시스템에 연동할 경우 실시간으로 여러분의 시스템이 쿠팡에 반영되게 함으로써 쿠팡 사이트에 여러분의 상품을 관리함에 따라 매출
                        향상 및 구매자 관리를 손쉽게 할 수
                        있습니다.</p>
                    <h3 className="mt40">별도의 제휴가 필요합니까?</h3>
                    <blockquote>
                        <p className="font14">
                            문의를 원하시는 경우 아래 메일 주소로 전송 부탁드립니다.<br/><br/>
                            수신자 : travel-api@coupang.com<br/>
                            제목 : [Open API 제휴문의][업체명]<br/>
                            ex) [Open API 제휴문의][쿠팡]<br/>
                        </p>
                    </blockquote>
                    <h3 className="mt40">Open API 연동 경험이 없습니다.</h3>
                    <p>걱정하지 마세요. Open API를 연동하는 일련의 과정들 즉 workflow Best Practice를 제공합니다.</p>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/IntroContent.jsx